// extracted by mini-css-extract-plugin
export default {"navigation":"PatientFileDialog_navigation__UCkww","navigationDetails":"PatientFileDialog_navigationDetails__xSPZI"};